import { Label, Text } from './InfoLabel.styled'

type InfoLabelProps = {
  label: string
  text: string
}

const InfoLabel: React.FC<InfoLabelProps> = ({ label, text }) => {
  return (
    <Label>
      {label}
      <Text>{text}</Text>
    </Label>
  )
}

export default InfoLabel
